import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import styled from 'styled-components';

import chatIcon from '../images/chat-solid-button.jpg';

const LiveChatStyled = styled.div`
  & .liveChat {
    position: fixed;
    bottom: 0;
    right: 70px;
    color: #0e2d6d;
    z-index: 92;
    width: 360px;
    @media (max-width: 767.98px) {
      right: 0px;
    }
  }
  .container {
    opacity: 1;
    animation: zoomIn 0.2s cubic-bezier(0.42, 0, 0.58, 1);
  }
  @keyframes zoomIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  & .liveChat .panel {
    margin-bottom: 0;
    border-radius: 0;
    border: 0;
    background-color: transparent !important;
  }

  & .liveChat .panel .panel-heading {
    margin-bottom: 0;
    padding: 0;
    background-color: #0e2d6d;
    border-radius: 0;
  }

  & .liveChat .panel .slidedown .glyphicon,
  .chat .glyphicon {
    margin-right: 5px;
  }

  & .liveChat .panel-body.chat-body {
    height: 450px;
    background-color: #0e2d6d;
    padding: 0;
  }

  & .liveChat .glyphicon {
    padding-top: 10px;
    padding-right: 20px;
    font-size: 18px;
  }

  & .liveChat span.glyphicon.glyphicon-minus {
    color: #fff;
    font-weight: bold;
    font-size: 26px;
    padding: 5px 10px;
  }

  & .liveChat #fbLiveChatModalLabel img {
    width: 100%;
  }

  & .liveChat .glyphicon-minus:before {
    content: '-';
    float: right;
    right: 10px;
    top: 5px;
    position: absolute;
  }

  & .liveChat .panel-heading img.chat_solid_button {
    display: inline-block;
    float: left;
  }

  & .liveChat iframe {
    border-width: 0;
  }

  & .liveChat .panel-heading .btn-group.pull-right {
    float: right !important;
  }
`;

const LiveChat = forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    toggleVisibility: () => {
      setIsVisible(!isVisible);
    },
  }));
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  return (
    <LiveChatStyled>
      {isVisible && (
        <div id="containerChat" className="container">
          <div className="row">
            <div className="liveChat">
              <div className="panel">
                <div className="panel-heading" id="accordion">
                  <LazyLoadImage className="chat_solid_button" alt="Let's chat" src={chatIcon} />
                  <div className="btn-group pull-right">
                    <a className="live-chat-close" href="#0" onClick={toggleVisibility}>
                      <span className="glyphicon glyphicon-minus" />
                    </a>
                  </div>
                </div>
                <div className="panel-body chat-body">
                  <iframe
                    title="livechat"
                    tabIndex="-1"
                    id="live-chat-window"
                    src="https://livechat.dwtc.com/csportalclient/refimplementation/DWTC.html"
                    width="100%"
                    height="100%"
                    data-deferred="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </LiveChatStyled>
  );
});
export default LiveChat;
